import { Component, OnInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort, Sort } from '@angular/material/sort';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Spinner } from 'src/app/core/services/spinner.service';
import { MESSAGE_TOAST } from 'src/app/shared/enums/message-toast-enum';
import { PATH_ROUTING } from 'src/app/shared/enums/routing-enums';
import { RequestOption } from 'src/app/shared/model/common.model';
import { ExcelService } from 'src/app/shared/service/excel.service';
import { GeTagRequestFormService } from 'src/app/shared/service/ge-tag-request-form.service';
import { MatTableDataSource } from "@angular/material/table";
import { environment } from 'src/environments/environment';
import { API_URL } from 'src/app/shared/enums/api-enums';

export interface STATUS {
  value: string;
  viewValue: string;
}

@Component({
  selector: 'app-ge-tag-statuses',
  templateUrl: './ge-tag-statuses.component.html',
  styleUrls: ['./ge-tag-statuses.component.scss']
})
export class GeTagStatusesComponent implements OnInit {

  displayedColumns = ['incidentId', 'incidentStatus', 'supplierName', 'gslNumber', 'date', 'isNewSupplier', 'updateDate', 'updateBy', 'action'];
  search = '';
  statuses: STATUS[] = [
    {
      value: 'NEW',
      viewValue: 'New'
    },
    {
      value: 'IN PROGRESS',
      viewValue: 'In Progress'
    },
    {
      value: 'PENDING',
      viewValue: 'Pending'
    },
    {
      value: 'COMPLETED',
      viewValue: 'Completed'
    },
    {
      value: 'RETURNED',
      viewValue: 'Returned'
    },
    {
      value: 'REJECTED',
      viewValue: 'Rejected'
    }

  ];
  status: any;
  dataSource: MatTableDataSource<any> = new MatTableDataSource([]);
  requestOption: RequestOption = new RequestOption();
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;

  constructor(private spinner: Spinner,
    private service: GeTagRequestFormService,
    private router: Router,
    private saveExcelFile: ExcelService,
    private toastService: ToastrService) { }

  ngOnInit() {
    this.getRequestData();
  }

  getRequestData() {
    this.spinner.show();
    this.service.getAllRecords().subscribe((res) => {
      if (res.data.length > 0) {
        console.log(res);
        this.dataSource.data = res.data.map(item => {
          const incidentData = JSON.parse(item.incidentPayload);
          item.supplierName = incidentData.supplierName;
          item.gslNumber = incidentData.gslNumber;
          item.isNewSupplier = incidentData.isNewSupplier === 'Y' ? 'Yes' : 'No';
          item.date = incidentData.date;
          item.shipToAddress = incidentData.shipToAddress;
          item.shipToCity = incidentData.shipToCity;
          item.shipToContactName = incidentData.shipToContactName;
          item.shipToState = incidentData.shipToState;
          item.shipToZip = incidentData.shipToZip;
          item.supplierName = incidentData.supplierName;
          item.phoneNumber = incidentData.phoneNumber;
          item.buyerName = incidentData.buyerName;
          item.comments = incidentData.comments;
          item.country = incidentData.country;
          item.business = incidentData.business;
          item.tagStyle = incidentData.tagStyle;
          item.requestorComments = incidentData.requestorComments;
          item.printingCompanyWorkflowNumber = incidentData.printingCompanyWorkflowNumber;
          item.uploadedFileUrl = incidentData.uploadedFileUrl;
          item.emailAddress = incidentData.emailAddress;
          item.dataRequestSentToPrintingCompany = incidentData.dataRequestSentToPrintingCompany;
          return item;
        });
      }
      this.spinner.hide();
    });
  }

  // searchData() {

  // }

  sortData(event: any) {

  }

  updateStatus(rowData) {
    this.router.navigate([PATH_ROUTING.PATH_SRM, PATH_ROUTING.PATH_ADMIN, 'update-status', rowData.incidentNumber], { state: { data: rowData } });
  }

  exportDetails() {
    window.open(`${environment.portalURL}${API_URL.GE_TAG_REQUEST_RECORDS_EXPORT}`);
  }

}
